import React from 'react';
import { Control } from 'react-hook-form';
import { FilterType } from '@/models';
import { FilterState } from '@/types/filter';
import { FilterSection } from '../../FilterSection/FilterSection';
import styles from './ScientificActivitiesView.module.css';

const LEFT_COLUMN_FILTERS = [FilterType.TOPIC, FilterType.TRIAL_SPONSOR, FilterType.CONGRESS, FilterType.PUBLICATION];

const RIGHT_COLUMN_FILTERS = [
  FilterType.SCIENTIFIC_ORGANIZATION,
  FilterType.CLINICAL_TRIAL,
  FilterType.SOCIAL_MEDIA,
  FilterType.GUIDELINE,
];

interface ScientificActivitiesViewProps {
  control: Control<FilterState>;
}

export const ScientificActivitiesView: React.FC<ScientificActivitiesViewProps> = ({ control }) => {
  return (
    <div className={styles.scientificActivitiesContainer}>
      <div className={styles.scientificActivitiesLeft}>
        <FilterSection
          defaultStateOpen={true}
          filterKeys={LEFT_COLUMN_FILTERS}
          formControl={control}
          useFloatingLabel={true}
        />
      </div>

      <div className={styles.scientificActivitiesRight}>
        <FilterSection
          defaultStateOpen={true}
          filterKeys={RIGHT_COLUMN_FILTERS}
          formControl={control}
          useFloatingLabel={true}
        />
      </div>
    </div>
  );
};
